<template>
  <div class="row mb-5" v-show="isLeader">
    <div class="col">
      <div class="row">
        <label class="col-form-label col-sm-3">Delavec (za dodeljevanje)</label>
        <div class="col-sm-9">
          <SelectEntity apiEntity="DropDown/Workers" v-model="selectedWorker" />
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-stripped table-sm">
      <thead>
        <tr>
          <th>Številka</th>
          <th>Status</th>
          <th scope="col">Zadeva</th>
          <th scope="col">Objekt</th>
          <th scope="col">Delavec</th>
          <th scope="col">Datum obiska</th>
          <th scope="col">Akcije</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in workOrders">
          <td @click="selectOrder(order, true)" class="bg-light">{{ order.orderNumber }}</td>
          <td><OrderBadge :workOrder="order" /></td>
          <td>{{ order.subject }} <!-- TODO duplicate -->
            <OrderIsBadge :workOrder="order" />
          </td>
          <td>{{ order.facilityName }}</td>
          <td>{{ order.owner }}</td>
          <td class="text-nowrap">
            <!-- #1761: once in a route, the route is the planned date -->
            <span v-if="order.plannedRouteDay" class="me-2" :title="order.plannedRouteWorker">V planu {{ $dayjs(order.plannedRouteDay).format($DATE_FORMAT_DISPLAY) }}</span>
            <span v-else-if="order.datePlannedVisit" class="me-2">{{ $dayjs(order.datePlannedVisit).format($DATE_FORMAT_DISPLAY) }}</span>
            <span v-else>—</span>

            <a href="#" class="text-danger"
              v-show="order.datePlannedVisit && !order.plannedRouteDay && isLeader"
              @click.prevent="$emit('setDatePlannedVisit', { order, datePlannedVisit: null })"
              title="Počisti datum">&times;</a>
          </td>
          <td>
            <button class="btn btn-sm btn-outline-success me-2"
            v-show="worker.fullName?.value !== order.owner"
            @click="$emit('assignTo', { order, selectedWorker: currentWorkerId })">Prevzemi</button>

            <button class="btn btn-sm btn-outline-success"
            v-show="isLeader && selectedWorker && canAssign(order)"
            @click="$emit('assignTo', { order, selectedWorker })">Dodeli</button>

            <a href="#" v-for="qd in $createQuickDates(0, 3)" :key="qd.offset" v-show="isLeader && !order.plannedRouteDay"
                class="me-1"
                @click.prevent="setQuickDate(order, qd.date)"
                :title="qd.date.format('ddd D.M.')">{{ qd.label }}</a>
          </td>
        </tr>
    </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorker } from "../composition-api/useWorker"
import { hasRole } from "../utils/roles"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  showMessageToWorker,
  currentWorkerId,
} from "../composition-api/useAuth"

defineOptions({ name: "WorkOrdersList" })

defineProps({
    workOrders: { type: Array, default: [] },
  })

const emit = defineEmits(["assignTo", "setDatePlannedVisit"])

const router = VueRouter.useRouter()
const selectedWorker = ref(null)
const { worker } = useWorker()

const isLeader = computed(() =>
  hasRole(role.value, ["LeaderService", "LeaderProduction", "LeaderProjects", "Administrator"]),
)

const canAssign = (order) => ["Active", "Accepted", "Triage"].includes(order.status)

const setQuickDate = (order, date) => {
  emit("setDatePlannedVisit", { order, datePlannedVisit: date.format("YYYY-MM-DD") })
}

const selectOrder = (order, openInNewWindow = false) => {
  // TODO: duplicate
  const routeData = router.resolve({ name: "ServiceOrder", params: { workOrderId: order.id } })
  if (openInNewWindow) {
    window.open(routeData.href, "_blank")
  } else {
    router.push(routeData)
  }
}
</script>
